module.exports = __webpack_public_path__ + "img/icon_expandir_modulo.b011e5ef.svg";